export const localeDirection = computed(() => {
  return useNuxtApp().$i18n.locale.value === 'ar' ? 'rtl' : 'ltr'
})